import payload_plugin_qLmFnukI99 from "/home/runner/work/pornplus/pornplus/frontend/node_modules/@pinia/nuxt/dist/runtime/payload-plugin.js";
import revive_payload_client_4sVQNw7RlN from "/home/runner/work/pornplus/pornplus/frontend/node_modules/nuxt/dist/app/plugins/revive-payload.client.js";
import unhead_KgADcZ0jPj from "/home/runner/work/pornplus/pornplus/frontend/node_modules/nuxt/dist/head/runtime/plugins/unhead.js";
import router_jmwsqit4Rs from "/home/runner/work/pornplus/pornplus/frontend/node_modules/nuxt/dist/pages/runtime/plugins/router.js";
import payload_client_yVLowv6hDl from "/home/runner/work/pornplus/pornplus/frontend/node_modules/nuxt/dist/app/plugins/payload.client.js";
import navigation_repaint_client_bs2bWDGRIE from "/home/runner/work/pornplus/pornplus/frontend/node_modules/nuxt/dist/app/plugins/navigation-repaint.client.js";
import check_outdated_build_client_8vK7RkfGxZ from "/home/runner/work/pornplus/pornplus/frontend/node_modules/nuxt/dist/app/plugins/check-outdated-build.client.js";
import chunk_reload_client_UciE0i6zes from "/home/runner/work/pornplus/pornplus/frontend/node_modules/nuxt/dist/app/plugins/chunk-reload.client.js";
import plugin_vue3_YdLad5Mpq3 from "/home/runner/work/pornplus/pornplus/frontend/node_modules/@pinia/nuxt/dist/runtime/plugin.vue3.js";
import components_plugin_KR1HBZs4kY from "/home/runner/work/pornplus/pornplus/frontend/.nuxt/components.plugin.mjs";
import prefetch_client_5tzzN0oIVL from "/home/runner/work/pornplus/pornplus/frontend/node_modules/nuxt/dist/pages/runtime/plugins/prefetch.client.js";
import plugin_adVF2uRka6 from "/home/runner/work/pornplus/pornplus/frontend/node_modules/nuxt-bugsnag/dist/runtime/client/plugin.js";
import plugin_PSbK9A48ZQ from "/home/runner/work/pornplus/pornplus/frontend/node_modules/pinia-plugin-persistedstate/dist/nuxt/runtime/plugin.js";
import plugin_Jozdw60ZsE from "/home/runner/work/pornplus/pornplus/frontend/node_modules/dayjs-nuxt/dist/runtime/plugin.js";
import slideovers_X7whXyrIWR from "/home/runner/work/pornplus/pornplus/frontend/node_modules/@nuxt/ui/dist/runtime/plugins/slideovers.js";
import modals_oqljskDzoR from "/home/runner/work/pornplus/pornplus/frontend/node_modules/@nuxt/ui/dist/runtime/plugins/modals.js";
import colors_ETtiVmZNmO from "/home/runner/work/pornplus/pornplus/frontend/node_modules/@nuxt/ui/dist/runtime/plugins/colors.js";
import plugin_client_OVoKJro5pc from "/home/runner/work/pornplus/pornplus/frontend/node_modules/@nuxtjs/color-mode/dist/runtime/plugin.client.js";
import plugin_WLsn00x1qh from "/home/runner/work/pornplus/pornplus/frontend/node_modules/@nuxt/icon/dist/runtime/plugin.js";
import vue_recaptcha_v3_uvzrnT4eW1 from "/home/runner/work/pornplus/pornplus/frontend/plugins/vue-recaptcha-v3.js";
import api_GFfDXud5Cr from "/home/runner/work/pornplus/pornplus/frontend/plugins/api.ts";
import caProvinces_ESa7x7UR3R from "/home/runner/work/pornplus/pornplus/frontend/plugins/caProvinces.js";
import fontawesome_cn2c4tOOHz from "/home/runner/work/pornplus/pornplus/frontend/plugins/fontawesome.ts";
import posthog_client_o9IEgU9LwG from "/home/runner/work/pornplus/pornplus/frontend/plugins/posthog.client.js";
import usStates_aWRTeE9TG4 from "/home/runner/work/pornplus/pornplus/frontend/plugins/usStates.js";
export default [
  payload_plugin_qLmFnukI99,
  revive_payload_client_4sVQNw7RlN,
  unhead_KgADcZ0jPj,
  router_jmwsqit4Rs,
  payload_client_yVLowv6hDl,
  navigation_repaint_client_bs2bWDGRIE,
  check_outdated_build_client_8vK7RkfGxZ,
  chunk_reload_client_UciE0i6zes,
  plugin_vue3_YdLad5Mpq3,
  components_plugin_KR1HBZs4kY,
  prefetch_client_5tzzN0oIVL,
  plugin_adVF2uRka6,
  plugin_PSbK9A48ZQ,
  plugin_Jozdw60ZsE,
  slideovers_X7whXyrIWR,
  modals_oqljskDzoR,
  colors_ETtiVmZNmO,
  plugin_client_OVoKJro5pc,
  plugin_WLsn00x1qh,
  vue_recaptcha_v3_uvzrnT4eW1,
  api_GFfDXud5Cr,
  caProvinces_ESa7x7UR3R,
  fontawesome_cn2c4tOOHz,
  posthog_client_o9IEgU9LwG,
  usStates_aWRTeE9TG4
]